import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop — every route change resets the page scroll to (0, 0).
 *
 * React Router v6 does NOT auto-scroll on navigation, which is why our
 * users kept landing mid-page after clicking any internal link.  Mount
 * this once, inside <BrowserRouter>, and every pathname change scrolls
 * the window back to the top.
 *
 * Exceptions:
 * - Hash links (e.g. `/faq#insurance`) still let the browser jump to the
 *   anchor instead of forcing top-of-page.
 * - The `state.preserveScroll` navigation flag lets specific links opt out
 *   (used by, say, in-page tab switches).
 */
const ScrollToTop = () => {
  const { pathname, hash, state } = useLocation();

  useEffect(() => {
    // Explicit opt-out for tabbed pages that swap the pathname but want
    // to keep the user in place (e.g. admin CMS tab switches later on).
    if (state && state.preserveScroll) return;

    // Let the browser handle in-page anchor jumps.
    if (hash) return;

    // Instant scroll — 'smooth' feels janky when the whole layout swaps.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash, state]);

  return null;
};

export default ScrollToTop;
